module.exports = __webpack_public_path__ + "static/machinelearning-98d361eda20335bef3537f218d17c721.png";